import React from "react";
import SupportDisputeDetailPage from "../dashboard/SupportDisputeDetailPage";
import {
  disputeExtractMessage,
  fetchMyAssignedSuperAdminDisputeById,
  postMyAssignedSuperAdminDisputeMessage,
  reopenManagedDispute,
  updateMyAssignedSuperAdminDisputeStatus,
} from "../../services/superAdminDispute.service";

const fetchGovernedDisputeDetail = async (id) => {
  const data = await fetchMyAssignedSuperAdminDisputeById(id);
  const managerPortal =
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/dashboard/support-manager");
  return {
    ...data,
    permissions: {
      canUpdateStatus: false,
      canSendPublicMessages: false,
      canAddInternalNotes: managerPortal,
      canReopen: managerPortal,
      statusRestrictionMessage: managerPortal
        ? "Support Managers monitor assigned disputes. Reassign before operational handling."
        : "Super Admin has read-only dispute oversight.",
    },
  };
};

export default function SuperAdminAssignedDisputeDetailPage({
  backPath = "/super-admin/disputes",
}) {
  return (
    <SupportDisputeDetailPage
      fetchDetail={fetchGovernedDisputeDetail}
      updateStatus={updateMyAssignedSuperAdminDisputeStatus}
      postMessage={postMyAssignedSuperAdminDisputeMessage}
      reopenDispute={reopenManagedDispute}
      extractMessage={disputeExtractMessage}
      backPath={backPath}
      backLabel="Dispute Management"
    />
  );
}
